import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import Select from 'react-select';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import CustomColumn from '../../../../../customControl/CustomColumn';
import { formatJsonDateToSQL } from '../../../../commonClass/CommonValidation';

const PickupDropAvailabilitySection = forwardRef((
    { ActivityAddressLocationId, PickUpDropPointXML, setPickUpDropPointXML, setPickUpDropDelete,
        formErrors, setFormErrors, dropdownData, disabled, setEditDisabled }, ref) => {


    const defaultPickupDropForm = {
        SeqNo: 0,
        ActivityPickUpDropPointId: 0,

        IsPickUpPoint: false,
        PickUpPointType: 0,
        PickUpPointId: 0,
        PickUpPointName: "",
        PickUpTime: null,

        IsDropPoint: false,
        DropPointType: 0,
        DropPointId: 0,
        DropPointName: "",
        DropTime: null
    }

    const [PickupDropForm, setPickupDropForm] = useState(defaultPickupDropForm);
    const [isPickupDropEdit, setIsPickupDropEdit] = useState(false);

    //#region pickup & drop options list
    const pickupList = useMemo(() => {
        return dropdownData?.pickupPointList?.filter((prev) => prev.LocationId === ActivityAddressLocationId) || [];
    }, [dropdownData?.pickupPointList, ActivityAddressLocationId])

    const dropList = useMemo(() => {
        return dropdownData?.dropPointList?.filter((prev) => prev.LocationId === ActivityAddressLocationId) || [];
    }, [dropdownData?.dropPointList, ActivityAddressLocationId])
    //#endregion

    //#region reset data on city change of Activity Point Address
    useEffect(() => {
        setPickupDropForm({ ...defaultPickupDropForm, IsPickUpPoint: PickupDropForm?.IsPickUpPoint, IsDropPoint: PickupDropForm?.IsDropPoint });
    }, [ActivityAddressLocationId])
    //#endregion

    //#region on change functions
    const handleOnChange = (name, value) => {
        setFormErrors(null);
        if (name === "IsPickUpPoint") {
            setPickupDropForm((prev) => ({
                ...prev,
                IsPickUpPoint: value,
                PickUpPointId: value ? prev?.PickUpPointId : 0,
                PickUpPointType: value ? prev?.PickUpPointType : 0,
                PickUpPointName: value ? prev?.PickUpPointName : "",
                PickUpTime: value ? prev?.PickUpTime : null,
            }));
        }
        else if (name === "IsDropPoint") {
            setPickupDropForm((prev) => ({
                ...prev,
                IsDropPoint: value,
                DropPointId: value ? prev?.DropPointId : 0,
                DropPointType: value ? prev?.DropPointType : 0,
                DropPointName: value ? prev?.DropPointName : "",
                DropTime: value ? prev?.DropTime : null,
            }));
        }
        else {
            setPickupDropForm((prev) => ({ ...prev, [name]: value }));
        }
    }

    const handleSelectChange = (name, data) => {
        setFormErrors(null);
        // if (data?.PointType === 5) {
        //     const value = name === "PickUpPointId" ? data?.PickupId : data?.DropId;
        //     const itemOtherPoint = dropdownData?.accessPointOtherList?.find((prev) => prev?.value === value && prev?.LocationId === data?.LocationId);
        //     setPickupDropForm((prev) => ({
        //         ...prev,
        //         IsPickUpPoint: true,
        //         PickUpPointType: itemOtherPoint?.PointType ? itemOtherPoint?.PointType : 0,
        //         PickUpPointId: itemOtherPoint?.value ? itemOtherPoint?.value : 0,
        //         PickUpPointName: itemOtherPoint?.PickUpPoint ? itemOtherPoint?.PickUpPoint : "",

        //         IsDropPoint: true,
        //         DropPointType: itemOtherPoint?.PointType ? itemOtherPoint?.PointType : 0,
        //         DropPointId: itemOtherPoint?.value ? itemOtherPoint?.value : 0,
        //         DropPointName: itemOtherPoint?.DropPoint ? itemOtherPoint?.DropPoint : "",
        //     }))
        // }
        // else {
        if (name === "PickUpPointId") {
            setPickupDropForm((prev) => ({ ...prev, PickUpPointId: data?.PickupId, PickUpPointType: data?.PointType, PickUpPointName: data?.label }));
        }
        else if (name === "DropPointId") {
            setPickupDropForm((prev) => ({ ...prev, DropPointId: data?.DropId, DropPointType: data?.PointType, DropPointName: data?.label }));
        }
        // }
    }
    //#endregion

    //#region validations on add/update of pickup & drop
    const validationOnAddUpdate = () => {
        let status = true;
        let error = {};

        if (!PickupDropForm?.IsPickUpPoint && !PickupDropForm?.IsDropPoint) {
            return false;
        }

        if (PickupDropForm?.IsPickUpPoint) {
            if (!PickupDropForm?.PickUpPointId || PickupDropForm?.PickUpPointId <= 0) {
                error.PickUpPointId = "Kindly Select Pick-Up Point";
                status = false;
            }
            if (PickupDropForm?.PickUpTime === null) {
                error.PickUpTime = "Input Is Mandatory, cannot leave blank";
                status = false;
            }
        }
        if (PickupDropForm?.IsDropPoint) {
            if (!PickupDropForm?.DropPointId || PickupDropForm?.DropPointId <= 0) {
                error.DropPointId = "Kindly Select Drop Point";
                status = false;
            }
            if (PickupDropForm?.DropTime === null) {
                error.DropTime = "Input Is Mandatory, cannot leave blank";
                status = false;
            }
        }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            status = false;
            const id = Object.keys(error)?.[0]
            document.getElementById(id)?.focus();
        }

        return status;
    }
    //#endregion

    //#region add/update/remove pickup & drop functions
    const handlePickupDropAddUpdate = () => {
        if (validationOnAddUpdate()) {
            if (isPickupDropEdit) {
                const updatedPickupDropCollection = PickUpDropPointXML?.map((obj) => {
                    if (obj?.SeqNo === PickupDropForm?.SeqNo) {
                        obj.SeqNo = PickupDropForm?.SeqNo;
                        obj.ActivityPickUpDropPointId = PickupDropForm?.ActivityPickUpDropPointId;

                        obj.IsPickUpPoint = PickupDropForm?.IsPickUpPoint ? PickupDropForm?.IsPickUpPoint : false;
                        obj.PickUpPointType = PickupDropForm?.PickUpPointType ? PickupDropForm?.PickUpPointType : 0;
                        obj.PickUpPointId = PickupDropForm?.PickUpPointId ? PickupDropForm?.PickUpPointId : 0;
                        obj.PickUpPointName = PickupDropForm?.PickUpPointName ? PickupDropForm?.PickUpPointName : "";
                        obj.PickUpTime = PickupDropForm?.PickUpTime ? PickupDropForm?.PickUpTime : null;

                        obj.IsDropPoint = PickupDropForm?.IsDropPoint ? PickupDropForm?.IsDropPoint : false;
                        obj.DropPointType = PickupDropForm?.DropPointType ? PickupDropForm?.DropPointType : 0;
                        obj.DropPointId = PickupDropForm?.DropPointId ? PickupDropForm?.DropPointId : 0;
                        obj.DropPointName = PickupDropForm?.DropPointName ? PickupDropForm?.DropPointName : "";
                        obj.DropTime = PickupDropForm?.DropTime ? PickupDropForm?.DropTime : null;
                    }
                    return obj;
                })
                setPickUpDropPointXML(updatedPickupDropCollection)
            }
            else {
                setPickUpDropPointXML((prev) => ([...prev, { ...PickupDropForm, SeqNo: PickUpDropPointXML?.length + 1 }]));
            }
            setEditDisabled(false);
            setPickupDropForm({ ...defaultPickupDropForm, IsPickUpPoint: PickupDropForm?.IsPickUpPoint, IsDropPoint: PickupDropForm?.IsDropPoint });
        }
        setIsPickupDropEdit(false);
    }

    const handlePickupDropEdit = (id) => {
        setFormErrors(null);
        setIsPickupDropEdit(true);
        const itemPickupDrop = PickUpDropPointXML?.find((prev) => prev?.SeqNo === id);
        setPickupDropForm((prev) => ({
            ...prev,
            SeqNo: id,
            ActivityPickUpDropPointId: 0,

            IsPickUpPoint: itemPickupDrop?.IsPickUpPoint ? itemPickupDrop?.IsPickUpPoint : false,
            PickUpPointType: itemPickupDrop?.PickUpPointType ? itemPickupDrop?.PickUpPointType : 0,
            PickUpPointId: itemPickupDrop?.PickUpPointId ? itemPickupDrop?.PickUpPointId : 0,
            PickUpPointName: itemPickupDrop?.PickUpPointName ? itemPickupDrop?.PickUpPointName : "",
            PickUpTime: itemPickupDrop?.PickUpTime ? itemPickupDrop?.PickUpTime : null,

            IsDropPoint: itemPickupDrop?.IsDropPoint ? itemPickupDrop?.IsDropPoint : false,
            DropPointType: itemPickupDrop?.DropPointType ? itemPickupDrop?.DropPointType : 0,
            DropPointId: itemPickupDrop?.DropPointId ? itemPickupDrop?.DropPointId : 0,
            DropPointName: itemPickupDrop?.DropPointName ? itemPickupDrop?.DropPointName : "",
            DropTime: itemPickupDrop?.DropTime ? itemPickupDrop?.DropTime : null,
        }))

    }

    const handlePickupDropRemove = (seqno, id) => {
        setEditDisabled(false);
        setFormErrors(null);
        setIsPickupDropEdit(false);
        setPickupDropForm(defaultPickupDropForm);
        id > 0 && setPickUpDropDelete((prev) => ([...prev, id]));
        setPickUpDropPointXML(PickUpDropPointXML?.filter((prev) => prev?.SeqNo !== seqno)?.map((obj, index) => { obj.SeqNo = index; return obj; }))
    }
    //#endregion

    //#region validations
    const validatePickupDropCollection = () => {
        let error = {};

        if (PickUpDropPointXML?.length <= 0) {
            error.PickUpDropPointXML = "Kindly add atleast one pick-up & drop availability";
        }

        setFormErrors(error);

        if (Object.keys(error)?.length > 0) {
            const id = Object.keys(error)?.[0];
            document.getElementById(id)?.focus();
        }

        return error;
    }
    //#endregion

    // Expose the childFunction to the parent's ref
    useImperativeHandle(ref, () => ({
        canValidate: false,
        validatePickupDropCollection: validatePickupDropCollection
    }))


    return (
        <>
            <div className="container-fluid form_border my-2 py-3">
                {/* Pick up Availability */}
                <h6 className="mb-3">
                    <strong>Pick Up Availability</strong>
                </h6>

                <div className="row">
                    <CustomColumn colNum={12} colLabel={2} colMDLabel={4} colChildren={6} colMDChildren={6} classChildren="align-content-center" labelText='Pick up Points' labelId='PickupPointRadio' >
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="pickupyes"
                                        className="form-check-input"
                                        name="pickup"
                                        value={1}
                                        checked={PickupDropForm?.IsPickUpPoint}
                                        onChange={() => handleOnChange("IsPickUpPoint", true)}
                                        disabled={disabled}
                                    />
                                    <label htmlFor="pickupyes" className="form-check-label"> Yes </label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="pickupno"
                                        className="form-check-input"
                                        name="pickup"
                                        value={2}
                                        checked={!PickupDropForm?.IsPickUpPoint}
                                        onChange={() => handleOnChange("IsPickUpPoint", false)}
                                        disabled={disabled}
                                    />
                                    <label htmlFor="pickupno" className="form-check-label"> No </label>
                                </div>
                            </div>
                        </div>
                    </CustomColumn>

                    <CustomColumn colNum={12} colLabel={2} colMDLabel={4} colChildren={6} colMDChildren={6} labelText='Pick Up Points' labelId='PickUpPointId' isRequired={PickupDropForm?.IsPickUpPoint} >
                        <Select
                            className="dropdown select_dropdown"
                            inputId='PickUpPointId'
                            options={pickupList}
                            value={pickupList?.find((obj) => obj?.PickupId === PickupDropForm?.PickUpPointId && obj?.PointType === PickupDropForm?.PickUpPointType) || 0}
                            onChange={(e) => handleSelectChange("PickUpPointId", e)}
                            isSearchable
                            isDisabled={disabled || !PickupDropForm?.IsPickUpPoint}
                            placeholder='Pick up Point'
                        />
                        {formErrors?.PickUpPointId && <div className="text-danger text-start fs_14">{formErrors?.PickUpPointId}</div>}
                    </CustomColumn>

                    <CustomColumn colNum={12} colLabel={2} colMDLabel={4} colChildren={6} colMDChildren={6} labelText='Pick Up Time' labelId='PickUpTime' isRequired={PickupDropForm?.IsPickUpPoint} >
                        <TimePicker
                            id='PickUpTime'
                            className='form-control defo_border'
                            disabled={disabled || !PickupDropForm?.IsPickUpPoint}
                            placeholder='--:--'
                            format='HH:mm:ss'
                            needConfirm={false}
                            showNow={false}
                            value={PickupDropForm?.PickUpTime ? dayjs(PickupDropForm?.PickUpTime) : null}
                            onChange={(e) => handleOnChange('PickUpTime', e?.$d ? formatJsonDateToSQL(e?.$d) : null)}
                        />
                        {formErrors?.PickUpTime && <div className="text-danger text-start fs_14">{formErrors?.PickUpTime}</div>}
                    </CustomColumn>
                </div>
                {/* Pick up Availability */}


                {/* Drop up Availability */}
                <h6 className="mb-3">
                    <strong>Drop Up Availability</strong>
                </h6>

                <div className="row">
                    <CustomColumn colNum={12} colLabel={2} colMDLabel={4} colChildren={6} colMDChildren={6} classChildren="align-content-center" labelText='Drop Points' labelId='DropupPointRadio'>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="dropupyes"
                                        className="form-check-input"
                                        name="dropup"
                                        value={1}
                                        checked={PickupDropForm.IsDropPoint}
                                        onChange={() => handleOnChange("IsDropPoint", true)}
                                        disabled={disabled}
                                    />
                                    <label htmlFor="dropupyes" className="form-check-label"> Yes </label>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="form-check">
                                    <input
                                        type="radio"
                                        id="dropupno"
                                        className="form-check-input"
                                        name="dropup"
                                        value={2}
                                        checked={!PickupDropForm.IsDropPoint}
                                        onChange={() => handleOnChange("IsDropPoint", false)}
                                        disabled={disabled}
                                    />
                                    <label htmlFor="dropupno" className="form-check-label"> No </label>
                                </div>
                            </div>
                        </div>
                    </CustomColumn>

                    <CustomColumn colNum={12} colLabel={2} colMDLabel={4} colChildren={6} colMDChildren={6} labelText='Drop points' labelId='DropPointId' isRequired={PickupDropForm?.IsDropPoint} >
                        <Select
                            className="dropdown select_dropdown"
                            inputId='DropPointId'
                            options={dropList}
                            value={dropList?.find((obj) => obj?.DropId === PickupDropForm?.DropPointId && obj?.PointType === PickupDropForm?.DropPointType) || 0}
                            onChange={(e) => handleSelectChange("DropPointId", e)}
                            isSearchable
                            isDisabled={disabled || !PickupDropForm?.IsDropPoint}
                            placeholder='Drop up Point'
                        />
                        {formErrors?.DropPointId && <div className="text-danger text-start fs_14">{formErrors?.DropPointId}</div>}
                    </CustomColumn>

                    <CustomColumn colNum={12} colLabel={2} colMDLabel={4} colChildren={6} colMDChildren={6} labelText='Pick Drop Time' labelId='DropupTime' isRequired={PickupDropForm?.IsDropPoint} >
                        <TimePicker
                            id='DropTime'
                            className='form-control defo_border'
                            disabled={disabled || !PickupDropForm?.IsDropPoint}
                            placeholder='--:--'
                            format='HH:mm:ss'
                            needConfirm={false}
                            showNow={false}
                            value={PickupDropForm?.DropTime ? dayjs(PickupDropForm?.DropTime) : null}
                            onChange={(e) => handleOnChange('DropTime', e?.$d ? formatJsonDateToSQL(e?.$d) : null)}
                        />
                        {formErrors?.DropTime && <div className="text-danger text-start fs_14">{formErrors?.DropTime}</div>}
                    </CustomColumn>
                </div>

                {/* Drop up Availability */}

                <div className="mt-4 text-center">
                    <button type="button" className='btn btn-primary' onClick={() => handlePickupDropAddUpdate()} disabled={disabled}> {isPickupDropEdit ? "Update" : "Add"} </button>
                </div>

                {formErrors?.PickUpDropPointXML && <div id='PickUpDropPointXML' className="text-danger text-center fs_14 my-2">{formErrors?.PickUpDropPointXML}</div>}


                <table className="table table-hover mt-2" >
                    <thead>
                        <tr>
                            <th>Pick Up Point</th>
                            <th className=''>Drop Point</th>
                            <th className='text-center'>Edit</th>
                            <th className='text-center'>Remove</th>
                        </tr>
                    </thead>
                    <tbody id="location-data">
                        {PickUpDropPointXML?.length > 0 && PickUpDropPointXML?.map((element, index) => {
                            return (
                                <tr className="ReactTable" key={element?.SeqNo}>
                                    <td >{element?.PickUpPointName}</td>
                                    <td className=''>{element?.DropPointName}</td>
                                    <td className='text-center'>
                                        <button
                                            type="button"
                                            onClick={(e) => { handlePickupDropEdit(element?.SeqNo, e) }}
                                            className="btn btn-primary mx-1"
                                            disabled={disabled ? true : false}
                                        >
                                            Edit
                                        </button>
                                    </td>
                                    <td className='text-center'>
                                        <button
                                            type="button"
                                            onClick={(e) => { handlePickupDropRemove(element?.SeqNo, element?.ActivityPickUpDropPointId) }}
                                            className="btn btn-primary mx-1"
                                            disabled={disabled ? true : false}
                                        >
                                            Remove
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

            </div>
        </>
    )
});

export default PickupDropAvailabilitySection